import { render, staticRenderFns } from "./edit-doctor.vue?vue&type=template&id=b725bb56&scoped=true"
import script from "./edit-doctor.vue?vue&type=script&lang=js"
export * from "./edit-doctor.vue?vue&type=script&lang=js"
import style0 from "./edit-doctor.vue?vue&type=style&index=0&id=b725bb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b725bb56",
  null
  
)

export default component.exports